import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Global } from "../global";
import { Router } from "@angular/router";
import { Http } from '@angular/http';
import { Headers } from '@angular/http';
import { AuthService } from "./auth/auth.service";
import { environment } from "src/environments/environment";

@Injectable()
export class ApiService {
    headerOptions: any;
    headers = new Headers();
    urlApi = environment.urlApi || null;
    constructor(
        private http: HttpClient,
        public global: Global,
        public router: Router,
        private http_: Http,
        private authService: AuthService,
    ) { }

    Get(path: any) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlApi}${path}`,
                {
                    headers: new HttpHeaders()
                        .set("Content-Type", "application/json")
                        .set("Authorization", `Bearer ${this.authService.authToken.value}`)
                })
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    GetFile(path: any) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlApi}${path}`,
                {
                    headers: new HttpHeaders()
                        .set("Content-Type", "application/x-myappname")
                        .set("Authorization", `Bearer ${this.authService.authToken.value}`)
                })
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    Delete(path: any) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.urlApi}${path}`,
                {
                    headers: new HttpHeaders()
                        .set("Content-Type", "application/json")
                        .set("Authorization", `Bearer ${this.authService.authToken.value}`)
                })
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    PostPublic(path: any, body: any) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlApi}${path}`, JSON.stringify(body),
                {
                    headers: new HttpHeaders()
                        .set("Content-Type", "application/json")
                })
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    Post(path: any, body: any) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlApi}${path}`, JSON.stringify(body),
                {
                    headers: new HttpHeaders()
                        .set("Content-Type", "application/json")
                        .set("Authorization", `Bearer ${this.authService.authToken.value}`)
                })
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    Put(path: any, body: any) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.urlApi}${path}`, JSON.stringify(body),
                {
                    headers: new HttpHeaders()
                        .set("Content-Type", "application/json")
                        .set("Authorization", `Bearer ${this.authService.authToken.value}`)
                })
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    Patch(path: any) {
        return new Promise((resolve, reject) => {
            this.http.patch(`${this.urlApi}${path}`, {},
                {
                    headers: new HttpHeaders()
                        .set("Content-Type", "application/json")
                        .set("Authorization", `Bearer ${this.authService.authToken.value}`)
                })
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    PatchAlterPassword(path: any, body: any, token: any) {
        return new Promise((resolve, reject) => {
            this.http.patch(`${this.urlApi}${path}`, JSON.stringify(body),
                {
                    headers: new HttpHeaders()
                        .set("Content-Type", "application/json")
                        .set("Authorization", `Bearer ${token}`)
                })
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    export(path:any) {
        return this.http.get(path,
            { responseType: 'blob' });
    }
}
